define("shared/components/shared/ui/calculating-state", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--calculatingWrapper">
    <div class="o--calculating u--m__b__lg"></div>
    <div class="o--calculating__desc" ...attributes>{{@text}}</div>
  </div>
  
  */
  {
    "id": "6se2zrYX",
    "block": "[[[10,0],[14,0,\"o--calculatingWrapper\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--calculating u--m__b__lg\"],[12],[13],[1,\"\\n  \"],[11,0],[24,0,\"o--calculating__desc\"],[17,1],[12],[1,[30,2]],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"&attrs\",\"@text\"],false,[]]",
    "moduleName": "shared/components/shared/ui/calculating-state.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});